import React, { FC } from 'react';
import ReactMarkdown from 'react-markdown';
import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { MarkdownContainer } from '../RecipeContent/MarkdownContainer';

export interface RecipeExcerptProps {
  children: string;
}

const Root = styled.div`
  color: ${globalTheme.palette.contrastHigh};
  font-size: ${globalTheme.font.size.xxs};
  line-height: ${globalTheme.font.size.md};
  margin-bottom: ${globalTheme.spacing.xl};
  word-break: break-word;
`;

export const RecipeExcerpt: FC<React.PropsWithChildren<RecipeExcerptProps>> = ({ children }) => (
  <MarkdownContainer>
    <Root>
      <ReactMarkdown disallowedTypes={['image']} linkTarget="_blank" escapeHtml={false}>
        {children}
      </ReactMarkdown>
    </Root>
  </MarkdownContainer>
);
